import clsx from 'clsx'
import { NavLink } from 'react-router'

import { ROUTES } from '@/app/router/paths'
import { isSectionInMenu, type SectionKey } from '@/app/router/sections'
import { STATION } from '@/config/station'
import { useTheme } from '@/services/theme/useTheme'
import {
  AlertIcon,
  CarIcon,
  HomeIcon,
  LogoIcon,
  MoonIcon,
  SunIcon,
  UsersIcon,
} from '@/shared/icons'
import { IconButton } from '@/shared/ui/IconButton'

import s from './Rail.module.css'

const NAV: ReadonlyArray<{
  key: SectionKey
  to: string
  label: string
  Icon: typeof HomeIcon
  end?: boolean
}> = [
  { key: 'home', to: ROUTES.home, label: 'Главная', Icon: HomeIcon, end: true },
  { key: 'clients', to: ROUTES.clients, label: 'Поток посетителей', Icon: UsersIcon },
  { key: 'cars', to: ROUTES.cars, label: 'Поток автомобилей', Icon: CarIcon },
  { key: 'events', to: ROUTES.events, label: 'События', Icon: AlertIcon },
]
/** В меню попадают только разделы в режиме menu (см. sections.ts). */
const VISIBLE_NAV = NAV.filter((item) => isSectionInMenu(item.key))

export function Rail() {
  const { mode, toggle } = useTheme()

  return (
    <aside className={s.rail}>
      <div className={s.station}>
        <LogoIcon />
        <div>
          <div className={s.name}>{STATION.name}</div>
          <div className={s.address}>{`${STATION.code} · ${STATION.city}, ${STATION.address}`}</div>
          <div className={s.brand}>Kepler Vision</div>
        </div>
      </div>

      <nav className={s.nav} aria-label="Разделы">
        {VISIBLE_NAV.map(({ to, label, Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => clsx(s.link, isActive && s.active)}
          >
            <Icon size={17} />
            {label}
          </NavLink>
        ))}
      </nav>

      <div className={s.foot}>
        <IconButton title={mode === 'dark' ? 'Светлая тема' : 'Тёмная тема'} onClick={toggle}>
          {mode === 'dark' ? <SunIcon size={15} /> : <MoonIcon size={15} />}
        </IconButton>
      </div>
    </aside>
  )
}
